module.exports = __webpack_public_path__ + "static/media/edit-image.eb0caaac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/edit-image.png
// module id = 607
// module chunks = 0